/* eslint-disable react/jsx-fragments */
/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Elements } from '../../elements';

import { contentCss } from './content-page.css';

import { PAGES__SHAPE_ITEM } from '../../../redux/constants';

export const ContentPage = (props) => {
  return (
    <div css={contentCss}>
      <Elements {...props} styles={props.page.css} omitHidden parentId={props.page.id} />
    </div>
  );
};

ContentPage.propTypes = {
  page: PAGES__SHAPE_ITEM.isRequired,
};
